import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/fundeasy_logo.png")